<template>
  <Component
    :is="tag"
    :id="text"
    class="rs-prop-title"
  >
    <RouterLink
      v-if="link"
      :to="link"
    >
      {{ $utils.decodeHtml(text) }}
    </RouterLink>

    <template v-else-if="pointer">
      <div
        class="d-inline"
        @click="$emit('expandedIdx')"
      >
        {{ $utils.decodeHtml(text) }}
      </div>
      <RsIcon
        v-if="isMouseOverTitle"
        class="property-link d-inline penIcon ml-1"
        icon="pencil"
      />
    </template>
    <template v-else>
      {{ $utils.decodeHtml(text) }}
    </template>
  </Component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPropTitle',
  props: {
    text: String,
    link: String,
    tag: {
      type: String,
      default: 'h4',
    },
    pointer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMouseOverTitle: false as boolean,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-prop-title{
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.6rem;
  a{
    color: $dark-gray;
    color: $primary-color;
    &:hover{
      color: $primary-color;
    }
    line-height: 1.6rem;
  }
}
.penIcon {
    color: $primary-color;
    font-size: 1.0rem;
  }
.property-link {
  &:hover {
    color: $primary-color;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
